import { createVanIconComponent } from "./van"

const CalendarOutlined = createVanIconComponent("calendar-o")
export default CalendarOutlined
